/**
 * TextArea, pure half.
 *
 * Moved verbatim from components/FlowBuilder/flow-components/components/TextAreaComponent.js. Runs unchanged in the
 * browser and, via the flow-core bundle, inside GraalJS on the backend, so it
 * must never reach for React, the DOM, Node APIs, or the network.
 */

import { labelLengthWarnings } from '../labelLength';
import { reservedFieldNameErrors } from '../fieldName';

export const TextAreaCore = {
  type: 'TextArea',
  name: 'Text Area',
  icon: '📄',
  description: 'Multi-line field for longer, free-form answers.',
  category: 'input',
  maxPerScreen: null,
  getDefaultProperties() {
    return {
      name: 'text_area',
      label: 'Enter text',
      required: false,
      'helper-text': '',
    };
  },
  getPropertySchema() {
    return {
      name: {
        type: 'string',
        label: 'Field Name',
        required: true,
      },
      label: {
        type: 'string',
        label: 'Label',
        required: true,
      },
      required: {
        type: 'boolean',
        label: 'Required',
        required: false,
      },
      'helper-text': {
        type: 'string',
        label: 'Helper Text',
        required: false,
      },
    };
  },
  validateProperties(properties) {
    const errors = [];
    const warnings = [];

    if (!properties.name || properties.name.trim().length === 0) {
      errors.push('Field name is required');
    }

    if (properties.name && !/^[a-zA-Z_][a-zA-Z0-9_]*$/.test(properties.name)) {
      errors.push('Field name must start with letter or underscore and contain only letters, numbers, and underscores');
    }

    errors.push(...reservedFieldNameErrors(properties.name));

    if (!properties.label || properties.label.trim().length === 0) {
      errors.push('Label is required');
    }

    warnings.push(...labelLengthWarnings('TextArea', properties.label));

    return { errors, warnings };
  },
  transformToWhatsApp(properties) {
    var result = {
      type: 'TextArea',
      name: properties.name,
      label: properties.label,
      required: properties.required || false,
    };

    if (properties['helper-text']) {
      result['helper-text'] = properties['helper-text'];
    }

    return result;
  },
  transformFromWhatsApp(whatsappComponent) {
    var helperText = whatsappComponent['helper-text'];
    if (typeof helperText === 'object' && helperText !== null) {
      helperText = helperText.text || '';
    }

    return {
      name: whatsappComponent.name,
      label: whatsappComponent.label,
      required: whatsappComponent.required || false,
      'helper-text': helperText || '',
    };
  },
};
